import { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { always, compose, tap } from 'ramda';

import { selectSelectedCompany } from 'companies/companies.slice';
import { getLegalDocuments } from 'shared/api/documentLibraryApi';
import { useErrorNotifier } from 'shared/custom-hooks/useNotifiers';
import { LibraryDocument } from 'document-library/document-library.types';
import store from 'store';

export function useLegalDocuments() {
  const dispatch = useDispatch<typeof store.dispatch>();
  const errorNotifier = useErrorNotifier();

  const [ legalDocs, setLegalDocs ] = useState<LibraryDocument[] | null>(null);

  const { compid: companyId } = useSelector(selectSelectedCompany) ?? { compid: undefined };

  const setDefault = compose(setLegalDocs, always([]));
  const [ handleError ] = useState(() => compose(tap(setDefault), errorNotifier));
  const mountedRef = useRef(false);

  useEffect(() => {
    mountedRef.current = true;

    if (companyId) {
      getLegalDocuments(companyId)
        .then((result) => {
          if (mountedRef.current) {
            setLegalDocs(result ?? []);
          }
        })
        .catch((err) => {
          if (mountedRef.current) {
            handleError(err);
          }
        });
    }

    return () => {
      mountedRef.current = false;
    };
  }, [ dispatch, companyId, handleError ]);

  return legalDocs;
}
